import { render } from "./Profile.vue?vue&type=template&id=ce17efbc&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=ce17efbc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ce17efbc"

export default script